<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const technologies = [
  // Cloud Platforms
  { name: 'Azure', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/azure/azure-original.svg' },
  { name: 'AWS', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg' },
  { name: 'GCP', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/googlecloud/googlecloud-original.svg' },
  
  // DevOps Tools
  { name: 'Kubernetes', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kubernetes/kubernetes-original.svg' },
  { name: 'Docker', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original-wordmark.svg' },
  { name: 'Terraform', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/terraform/terraform-original.svg' },
  { name: 'Ansible', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/ansible/ansible-original.svg' },
  
  // Programming Languages
  { name: 'Go', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/go/go-original-wordmark.svg' },
  { name: 'C++', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cplusplus/cplusplus-original.svg' },
  { name: 'Python', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg' },
  { name: 'C#', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/csharp/csharp-original.svg' },
  { name: 'dotnet', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/dotnetcore/dotnetcore-original.svg' },
  
  // Frameworks & SDKs
  { name: 'Flutter', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg' },
  { name: 'Unity', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/unity/unity-original.svg' },
  
  // Databases
  { name: 'PostgreSQL', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg' },
  { name: 'SQL Server', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/microsoftsqlserver/microsoftsqlserver-original.svg' },
  
  // AI/ML Frameworks
  { name: 'scikit-learn', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/scikitlearn/scikitlearn-original.svg' },
  { name: 'PyTorch', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/pytorch/pytorch-original.svg' },
  { name: 'TensorFlow', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tensorflow/tensorflow-original.svg' },
  { name: 'Keras', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/keras/keras-original.svg' }
];
</script>

<template>
  <section class="relative py-16 overflow-hidden">
    <!-- Background image -->
    <div 
      class="absolute inset-0 z-0" 
      style="
        background-image: url('/4854866.jpg');
        background-size: cover;
        background-position: center;
        opacity: 1;
      "
    ></div>

    <div class="absolute inset-0 bg-white bg-opacity-25 z-0"></div>

    <!-- Diagonal clips -->
    <div class="absolute inset-0">
      <!-- Upper diagonal clip -->
      <div class="absolute top-0 left-0 right-0 h-16 bg-white"
           style="clip-path: polygon(0 0, 100% 0, 100% 100%, 0 0);">
      </div>
      <!-- Lower diagonal clip -->
      <div class="absolute bottom-0 left-0 right-0 h-16 bg-gray-50"
           style="clip-path: polygon(0 100%, 100% 100%, 100% 0, 0 100%);">
      </div>
    </div>

    <div class="container mx-auto px-4 relative">
      <!-- Section Title -->
      <h2 class="text-3xl font-bold mb-12">
        {{ t('technologySection.heading') }}
        <div class="h-1 bg-red-500 w-20 mt-2"></div>
      </h2>

      <!-- Technology Grid -->
      <div class="max-w-3xl mb-16">
        <div class="grid grid-cols-4 gap-4">
          <div v-for="tech in technologies" 
               :key="tech.name" 
               class="bg-black bg-opacity-25 p-3 rounded border border-gray-700 hover:border-gray-600 transition-colors">
            <div class="h-8 flex items-center justify-center">
              <img :src="tech.logo" 
                   :alt="tech.name"
                   class="max-h-full max-w-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>